import React, {
    useEffect,
    useState,
    useRef,
    Fragment,
} from 'react';
import PaymentMethodSelector from '../../shared/PaymentMethodSelector';
import { useDispatch, useSelector } from 'react-redux';
import { Autocomplete, CircularProgress, Divider, FormControlLabel, Radio, RadioGroup, TextField } from '@mui/material';
import { Button, FormHelperText } from '@mui/material';
import OutlinedInput from '@mui/material/OutlinedInput';
import { getData, postData } from '../../services/fetch-service';
import { useNavigate } from 'react-router-dom';
import { useFormik } from 'formik';
import * as Yup from 'yup'
import PayseraPayment from '../PayseraPayment';
import dayjs from 'dayjs';
import { FaEuroSign } from 'react-icons/fa';
import ReCAPTCHA from 'react-google-recaptcha';
import { LoadingOverlay, Loader } from '@mantine/core';
import { setPaymentResponse } from '../store/dataslice';
import Swal from 'sweetalert2';

const customLoader = (
    <div className="payment-load">
        <Loader color="#006" />
        <span>Në procesim...</span>
    </div>
);

const Uniref_PaymentFields = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const reCaptchaRef = useRef(null);
    const SelectedPayment = useSelector((state) => state.Website.data.PaymentSelected);

    const [NumriSerik, setNumriSerik] = useState();
    const [kerkoLoading, setKerkoLoading] = useState(false);
    const [InstitucioniServiceData, setInstitucioniServiceData] = useState(null);
    const [paymentMethodCode, setPaymentMethodCode] = useState("wallet");

    // console.log('InstitucioniServiceData', InstitucioniServiceData);

    const [personType, setPersonType] = useState('Fizik');
    const [selectedInstitucioni, setSelectedInstitucioni] = useState(null);

    const [selectedLlojiPageses, setSelectedLlojiPageses] = useState(null);
    const [pagesaLoading, setPagesaLoading] = useState(false);
    const [loanLoading, setLoanLoading] = useState(false);
    const [updateLoader, setUpdateLoader] = useState(false);
    const [Loan, setLoan] = useState(false);

    const handleBack = () => {
        navigate('/');
    }

    // kerkimi me uniref
    // const fetchInstitucioniServiceData = async (token) => {
    //     try {
    //         const response = await getData(`Pagesat/GetKontrolloPagesat?uniref=${NumriSerik}&SherbimiTipiID=3&token=${token}&boxTypeId=1`);
    //         if (response) {
    //             setInstitucioniServiceData(response.data);
    //             setKerkoLoading(false);
    //         }
    //     } catch (error) {
    //         setKerkoLoading(false);
    //         setInstitucioniServiceData(null);
    //         Swal.fire({
    //             icon: 'error',
    //             title: 'Gabim',
    //             text: 'Pagesa me këtë shifër të Uniref nuk është gjetur!'
    //         });
    //     }
    // };

    const fetchInstitucioniServiceData = async (token) => {
        try {
            const response = await postData('Pagesat/GetKontrolloPagesat', {
                SherbimiTipiID: 3,
                uniref: NumriSerik,
                token: token,
                boxTypeId: 1
            });
            if (response) {
                setInstitucioniServiceData(response.data);
                setKerkoLoading(false);
            }
        } catch (error) {
            setKerkoLoading(false);
            setInstitucioniServiceData(null);
            Swal.fire({
                icon: 'error',
                title: 'Gabim',
                text: "Pagesa me këtë UNIREF nuk është gjetur!",
            });
        }
    };

    async function handleSearch() {
        reCaptchaRef.current.reset();
        try {
            setKerkoLoading(true);
            const token = await reCaptchaRef.current.executeAsync();
            fetchInstitucioniServiceData(token);
        } catch (error) {
            setKerkoLoading(true);
        }
    };
    // *** kerkimi me uniref *** END

    const handlePaymentMethodCode = (event) => {
        setPaymentMethodCode(event.target.value);
    };

    const clickPaymentMethodCode = (value) => {
        setPaymentMethodCode(value);
    };

    //  add vlera per institucionin dhe llojin e pageses
    const getInstitucioniId = async (id) => {
        try {
            const response = await getData(`Pagesat/GetInstitucioniID?InstitucioniId=${id}`);
            if (response) {
                const options = response.data.map(({ institutionId, name }) => ({ label: name, id: institutionId }));
                setSelectedInstitucioni(options)

                if (options && options[0].id) {
                    formik.setFieldValue('institucioniId', options.id)
                } else {
                    formik.setFieldValue('institucioniId', '')
                }
            }
        } catch (error) {
            Swal.fire({
                icon: 'error',
                title: 'Gabim',
                text: 'Pagesa me këtë shifër të Uniref nuk është gjetur!'
            });
        }
    };

    const getLlojiPagesesId = async (id) => {
        try {
            const response = await getData(`Pagesat/GetLlojiPagesesID?LlojiPagesesID=${id}`);
            if (response) {
                const options = response.data.map(({ id, emertimi }) => ({ label: emertimi, id: id }));
                setSelectedLlojiPageses(options)

                if (options && options[0].id) {
                    formik.setFieldValue('llojiPagesesID', options.id)
                } else {
                    formik.setFieldValue('llojiPagesesID', '')
                }
            }
        } catch (error) {
            Swal.fire({
                icon: 'error',
                title: 'Gabim',
                text: 'Pagesa me këtë shifër të Uniref nuk është gjetur!'
            });
        }
    };

    useEffect(() => {
        if (InstitucioniServiceData) {
            getInstitucioniId(InstitucioniServiceData.institucioniId);
            getLlojiPagesesId(InstitucioniServiceData.llojiPagesesID);
        }
    }, [InstitucioniServiceData]);
    //  *** add vlera per institucionin dhe llojin e pageses *** END

    const payment_validationSchema = Yup.object().shape({
        Email: Yup.string().email('Email nuk është valid!').required('Email është obligativ!'),
        emri: Yup.string().required('Emri është obligative!'),
        llojiKlientit: Yup.string(),
        mbiemri: Yup.string().test('isRequiredForFizik', 'Mbiemri është obligativ', function (value) {
            const { llojiKlientit } = this.parent;
            if (llojiKlientit === 'Fizik') {
                return !!value;
            }
            return true;
        }),
        strVlera: Yup.string().required('Fusha është obligative!'),
    });

    const today = new Date();
    const strDataPageses = dayjs(today).format('DD/MM/YYYY');

    const formik = useFormik({
        initialValues: {
            Email: '',
            provizioni: 0,
            strProvizioni: '0',
            llojiPagesesID: '',
            numriIdentifikues: '',
            institucioniId: '',
            numriSerik: `${NumriSerik}`,
            strDataPageses: `${strDataPageses}`,
            llojiKlientit: 'Fizik',
            emri: '',
            mbiemri: '',
            pershkrimi: 'Pagesa online',
            strVlera: '',
            strVleraTotale: '0',
            paymentMethod: 3,
            sherbimiTipiID: 7,
            // shpenzimet: 0,
            unirefOK: false,
        },
        validationSchema: payment_validationSchema,
        onSubmit: (values) => {
            reCaptchaRef.current.reset();
            postPagesaPerSherbime(values);
        },
    });

    const postPagesaPerSherbime = async (data) => {
        const token = await reCaptchaRef.current.executeAsync();
        try {
            setUpdateLoader(true);
            const newData = {
                ...data,
                mbiemri: data.mbiemri !== '' ? data.mbiemri : '//',
                shuma: provizioni && provizioni.strShuma.replace(/,/g, ''),
                provizioni: provizioni && provizioni.provizioni,
                viti: `${new Date().getFullYear()}`,
                numriIdentifikues: data.numriIdentifikues !== '' ? `${data.numriIdentifikues}` : '',
                strProvizioni: `${provizioni && provizioni.provizioni}`,
                LlojiPagesesID: selectedLlojiPageses && selectedLlojiPageses[0].id,
                numriSerik: NumriSerik,
                numriUnikPageses: NumriSerik,
                strDataPageses: `${strDataPageses}`,
                strVlera: `${provizioni && provizioni.strShuma}`,
                strVleraTotale: `${provizioni && provizioni.strtotal_pagesa}`,
                token: token,
                PayWithLoan: Loan ? true : false,
                PaymentMethodCode: paymentMethodCode
            }
            if (provizioni) {
                const response = await postData('Pagesat/PagesaPerSherbime', newData);
                if (response && response.status === 200) {
                    // if (!Loan && paymentMethodCode !== 'visa') {
                    //     dispatch(setPaymentResponse(response.data.respond));
                    //     setPagesaLoading(false);
                    // } else {
                    //     setLoanLoading(false);
                    //     const paymentWindow = window.open('', '_self');
                    //     paymentWindow.location.href = `${response.data.link}`;
                    // }
                    setLoanLoading(false);
                    setPagesaLoading(false);
                    setUpdateLoader(false);
                    const paymentWindow = window.open('', '_self');
                    paymentWindow.location.href = `${response.data.link}`;
                }
            }
        } catch (error) {
            setPagesaLoading(false);
            setLoanLoading(false);
            setUpdateLoader(false);
            Swal.fire({
                icon: 'error',
                title: 'Gabim',
                text: `${error.response ? error.response.data.modelState.Error.errors[0].errorMessage : "Pagesa dështoi!"}`
            });
        }
    }

    const handlePayProcess = () => {
        if (paymentMethodCode === "PaySeraKredi") {
            handlePayWithLoan();
        } else {
            handlePay();
        }
    }

    const handlePay = async () => {
        formik.validateForm().then(async (errors) => {
            if (Object.keys(errors).length === 0) {
                setPagesaLoading(true);
                await getProvizioni();
                formik.handleSubmit();
            } else {
                formik.setTouched(Object.keys(formik.values).reduce((acc, key) => {
                    acc[key] = true;
                    return acc;
                }, {}));
            }
        });
    };

    const handlePayWithLoan = () => {
        formik.validateForm().then((errors) => {
            if (Object.keys(errors).length === 0) {
                setLoanLoading(true);
                setLoan(true);
                formik.handleSubmit();
            } else {
                formik.setTouched(Object.keys(formik.values).reduce((acc, key) => {
                    acc[key] = true;
                    return acc;
                }, {}));
            }
        });
    }

    const handlePersonTypeChange = (event, newValue) => {
        setPersonType(event.target.value);
        formik.setFieldValue('llojiKlientit', event.target.value)
    };

    // provisioni
    const [provizioni, setProvizioni] = useState(null);
    const [shumaKey, setShumaKey] = useState(0);

    const getProvizioni = async (data) => {
        try {
            const response = await getData(`Pagesat/GetProvision?LlojiPagesesID=${selectedLlojiPageses && selectedLlojiPageses[0].id}&Amount=${formik.values.strVlera}`, data);
            if (response && response.data && response.data.success === true) {
                setProvizioni(response.data)
            } else if (response && response.data && response.data.success === false) {
                Swal.fire({
                    icon: 'warning',
                    title: 'Informim',
                    text: `${response.data.responseText}`
                });
                formik.setFieldValue('strVlera', null);
                setProvizioni(null);
                setShumaKey(prev => prev + 1);
            }
        } catch (error) {
            // Swal.fire({
            //     icon: 'error',
            //     title: 'Gabim',
            //     text: 'Ka ndodhur një gabim. Nuk ka provizion aktiv për këtë lloj pagese dhe shumë. Ju lutem kontaktoni administratorët.'
            // });
            formik.setFieldValue('strVlera', null);
            setProvizioni(null);
            setShumaKey(prev => prev + 1);
            // setInstitucioniList(null);
        }
    }

    // useEffect(() => {
    //     if (formik.values.strVlera !== '') {
    //         getProvizioni();
    //     }
    // }, [selectedLlojiPageses, formik.values.strVlera]);
    // *** provisioni *** end

    return (
        <div className="paysera-home paysera-feilds">
            <div className="home-header home-header-others">
                <h1 className='headline-font'>
                    {SelectedPayment.description}
                </h1>
                {/* <span className='home-description body-font'>There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form</span> */}
            </div>
            <div className="paysera-form-body other-feilds">
                <div className="form-box search-box">
                    <div className="form-body search-body">
                        <div className="paysera-form search-s">
                            <div className="paysera-inputLabel s-Label">
                                <label htmlFor="Numri Serik">Kërko përmes UNIREF <span className="required">*</span></label>
                                <div className="s-input">
                                    <OutlinedInput
                                        size="small"
                                        type="text"
                                        // autoFocus
                                        style={{ WebkitAppearance: 'textfield' }}
                                        id="outlined-adornment-input"
                                        placeholder="UNIREF"
                                        aria-describedby="outlined-input-helper-text"
                                        inputProps={{
                                            'aria-label': 'input',
                                            // autoComplete: 'off',
                                            // inputMode: 'text'
                                        }}
                                        onChange={(event) => setNumriSerik(event.target.value)}
                                        onKeyPress={(event) => {
                                            if (event.key === 'Enter' && NumriSerik !== undefined) {
                                                handleSearch();
                                            }
                                        }}
                                    />
                                    <Button
                                        type="button"
                                        className="dynamic-button"
                                        variant="contained"
                                        onClick={handleSearch}
                                        disabled={kerkoLoading || NumriSerik === undefined || NumriSerik === ''}
                                    >
                                        {kerkoLoading ? <CircularProgress size={24} /> : 'Kërko'}
                                    </Button>
                                </div>
                            </div>
                        </div>
                    </div>
                    {InstitucioniServiceData && (
                        <Fragment>
                            <Divider className='subheading-font' textAlign="center">Të dhënat e Institucionit</Divider>
                            <div className="paysera-form">
                                <div className="paysera-select">
                                    <label
                                        className={formik.touched.institucioniId && formik.errors.institucioniId ? 'label-top' : ''}
                                        htmlFor="Institucioni"
                                    >
                                        Institucioni <span className="required">*</span>
                                    </label>
                                    <Autocomplete
                                        disablePortal
                                        disabled
                                        id="combo-box-demo"
                                        options={selectedInstitucioni}
                                        value={selectedInstitucioni && selectedInstitucioni[0]}
                                        sx={{ width: 300 }}
                                        size='small'
                                        name='institucioniId'
                                        loading={selectedInstitucioni && selectedInstitucioni.length === 0 ? true : false}
                                        loadingText={
                                            <div className="dropdownLoader">
                                                <CircularProgress size={20} color="inherit" />
                                            </div>
                                        }
                                        noOptionsText={
                                            selectedInstitucioni && selectedInstitucioni.length === 0 &&
                                            (
                                                <div className="dropdownLoader">
                                                    <CircularProgress size={20} color="inherit" />
                                                </div>
                                            )
                                        }
                                        renderInput={(params) => (
                                            <div className="input">
                                                <TextField
                                                    {...params}
                                                    label=""
                                                    variant="outlined"
                                                    placeholder='Zgjedh institucionin'
                                                    fullWidth
                                                    error={formik.touched.institucioniId && formik.errors.institucioniId}
                                                />
                                                {
                                                    formik.touched.institucioniId && formik.errors.institucioniId && (
                                                        <FormHelperText>{formik.errors.institucioniId}</FormHelperText>
                                                    )
                                                }
                                            </div>
                                        )}
                                    />
                                </div>
                                <div className="paysera-select">
                                    <label
                                        className={formik.touched.llojiPagesesID && formik.errors.llojiPagesesID ? 'label-top' : ''}
                                        htmlFor="Lloji Pagesës"
                                    >
                                        Lloji Pagesës <span className="required">*</span>
                                    </label>
                                    <Autocomplete
                                        disablePortal
                                        id="combo-box-demo"
                                        options={selectedLlojiPageses}
                                        value={selectedLlojiPageses && selectedLlojiPageses[0]}
                                        loading={selectedLlojiPageses && selectedLlojiPageses.length === 0 ? true : false}
                                        loadingText={
                                            <div className="dropdownLoader">
                                                <CircularProgress size={20} color="inherit" />
                                            </div>
                                        }
                                        noOptionsText={
                                            selectedLlojiPageses && selectedLlojiPageses.length === 0 &&
                                            (
                                                <div className="dropdownLoader">
                                                    <CircularProgress size={20} color="inherit" />
                                                </div>
                                            )
                                        }
                                        sx={{ width: 300 }}
                                        disabled
                                        size='small'
                                        name='llojiPagesesID'
                                        onBlur={formik.handleBlur}
                                        renderInput={(params) => (
                                            <div className="input">
                                                <TextField
                                                    {...params}
                                                    label=""
                                                    variant="outlined"
                                                    placeholder="Zgjedh llojin e pagesës"
                                                    fullWidth
                                                    error={formik.touched.llojiPagesesID && formik.errors.llojiPagesesID}
                                                />
                                                {
                                                    formik.touched.llojiPagesesID && formik.errors.llojiPagesesID && (
                                                        <FormHelperText>{formik.errors.llojiPagesesID}</FormHelperText>
                                                    )
                                                }
                                            </div>
                                        )}
                                    />
                                </div>
                            </div>
                        </Fragment>
                    )}
                </div>
                <div className="form-box">
                    <Divider className='subheading-font' textAlign="center">Detajet e pagesës</Divider>
                    <div className="form-body">
                        {InstitucioniServiceData ? (
                            <div className="paysera-form">
                                <div className="radio-person">
                                    <RadioGroup
                                        row
                                        aria-labelledby="demo-row-radio-buttons-group-label"
                                        name="llojiKlientit"
                                        value={personType}
                                        onChange={handlePersonTypeChange}
                                    >
                                        <FormControlLabel value="Fizik" control={<Radio />} label="Person Fizik" />
                                        <FormControlLabel value="Juridik" control={<Radio />} label="Person Juridik" />
                                    </RadioGroup>
                                </div>
                                <div className="paysera-inputLabel">
                                    <label
                                        className={formik.touched.emri && formik.errors.emri ? 'label-top' : ''}
                                        htmlFor={personType === 'Fizik' ? 'Emri' : 'Emri i Kompanisë'}
                                    >
                                        {personType === 'Fizik' ? 'Emri' : 'Emri i Kompanisë'}
                                        <span className="required"> *</span>
                                    </label>
                                    <div className="input">
                                        <OutlinedInput
                                            size="small"
                                            id="outlined-adornment-input"
                                            placeholder={personType === 'Fizik' ? 'Emri' : 'Emri i Kompanisë'}
                                            type='text'
                                            name='emri'
                                            aria-describedby="outlined-input-helper-text"
                                            inputProps={{
                                                'aria-label': 'input',
                                            }}
                                            value={formik.values.emri}
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            error={formik.touched.emri && formik.errors.emri}
                                        />
                                        {
                                            formik.touched.emri && formik.errors.emri && (
                                                <FormHelperText>{formik.errors.emri}</FormHelperText>
                                            )
                                        }
                                    </div>
                                </div>
                                {personType === 'Fizik' &&
                                    <div className="paysera-inputLabel">
                                        <label
                                            htmlFor="mbiemri"
                                            className={formik.touched.mbiemri && formik.errors.mbiemri ? 'label-top' : ''}
                                        >
                                            Mbiemri
                                            <span className="required"> *</span>
                                        </label>
                                        <div className="input">
                                            <OutlinedInput
                                                size="small"
                                                id="outlined-adornment-input"
                                                placeholder="Mbiemri"
                                                type='text'
                                                aria-describedby="outlined-input-helper-text"
                                                inputProps={{
                                                    'aria-label': 'input',
                                                }}
                                                name='mbiemri'
                                                value={formik.values.mbiemri}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                error={formik.touched.mbiemri && formik.errors.mbiemri}
                                            />
                                            {
                                                formik.touched.mbiemri && formik.errors.mbiemri && (
                                                    <FormHelperText>{formik.errors.mbiemri}</FormHelperText>
                                                )
                                            }
                                        </div>
                                    </div>
                                }
                                <div className="paysera-inputLabel">
                                    <label className={formik.touched.Email && formik.errors.Email ? 'label-top' : ''} htmlFor="Numri Serik">Email <span className="required">*</span></label>
                                    <div className="input">
                                        <OutlinedInput
                                            size="small"
                                            id="outlined-adornment-input"
                                            placeholder="Shëno email-in tuaj"
                                            name='Email'
                                            type="email"
                                            aria-describedby="outlined-input-helper-text"
                                            inputProps={{
                                                'aria-label': 'input',
                                            }}
                                            value={formik.values.Email}
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            error={formik.touched.Email && formik.errors.Email}
                                        />
                                        {
                                            formik.touched.Email && formik.errors.Email && (
                                                <FormHelperText>{formik.errors.Email}</FormHelperText>
                                            )
                                        }
                                    </div>
                                </div>
                                {personType === 'Fizik' ?
                                    (
                                        <div className="paysera-inputLabel">
                                            <label htmlFor="numriIdentifikues" >Nr. Personal</label>
                                            <div className="input">
                                                <OutlinedInput
                                                    size="small"
                                                    id="outlined-adornment-input"
                                                    placeholder="Nr. Personal"
                                                    type='number'
                                                    aria-describedby="outlined-input-helper-text"
                                                    inputProps={{
                                                        'aria-label': 'input',
                                                        inputMode: 'numeric'
                                                    }}
                                                    name='numriIdentifikues'
                                                    value={formik.values.numriIdentifikues}
                                                    onChange={formik.handleChange}
                                                    onBlur={formik.handleBlur}
                                                />
                                            </div>
                                        </div>
                                    )
                                    : (
                                        <div className="paysera-inputLabel">
                                            <label htmlFor="nrBiznesit">Nr. Biznesit</label>
                                            <div className="input">
                                                <OutlinedInput
                                                    size="small"
                                                    id="outlined-adornment-input"
                                                    placeholder="Nr. Biznesit"
                                                    type='number'
                                                    aria-describedby="outlined-input-helper-text"
                                                    inputProps={{
                                                        'aria-label': 'input',
                                                        inputMode: 'numeric'
                                                    }}
                                                    name='nrBiznesit'
                                                    value={formik.values.nrBiznesit}
                                                    onChange={formik.handleChange}
                                                    onBlur={formik.handleBlur}
                                                />
                                            </div>
                                        </div>
                                    )
                                }
                                <div className="paysera-inputLabel">
                                    <label htmlFor="Numri Serik">Adresa</label>
                                    <OutlinedInput
                                        size="small"
                                        id="outlined-adornment-input"
                                        placeholder="Adresa"
                                        aria-describedby="outlined-input-helper-text"
                                        name='paguesiAdresa'
                                        onChange={(event) => formik.setFieldValue('paguesiAdresa', event.target.value)}
                                        inputProps={{
                                            'aria-label': 'input',
                                        }}
                                    />
                                </div>
                                <div className="paysera-inputLabel">
                                    <label
                                        className={formik.touched.strVlera && formik.errors.strVlera ? 'label-top' : ''}
                                        htmlFor="Shuma e pagesës"
                                    >
                                        Shuma e pagesës <span className="required">*</span>
                                    </label>
                                    <div className="input">
                                        <OutlinedInput
                                            size="small"
                                            id="outlined-adornment-input"
                                            placeholder="€"
                                            className='number-input'
                                            type='number'
                                            aria-describedby="outlined-input-helper-text"
                                            key={shumaKey}
                                            inputProps={{
                                                'aria-label': 'input',
                                                inputMode: 'numeric'
                                            }}
                                            endAdornment={<FaEuroSign />}
                                            name='strVlera'
                                            value={formik.values.strVlera}
                                            onChange={(e) => {
                                                const stringValue = e.target.value.toString().replace(/,/g, '');
                                                formik.handleChange({
                                                    target: {
                                                        name: 'strVlera',
                                                        value: stringValue,
                                                    },
                                                });
                                            }}
                                            onBlur={(e) => {
                                                formik.handleBlur(e);
                                                getProvizioni();
                                            }}
                                            error={formik.touched.strVlera && formik.errors.strVlera}
                                        />
                                        {
                                            formik.touched.strVlera && formik.errors.strVlera && (
                                                <FormHelperText>{formik.errors.strVlera}</FormHelperText>
                                            )
                                        }
                                    </div>
                                </div>
                                <div className="paysera-inputLabel">
                                    <label htmlFor="Provizioni"> Provizioni</label>
                                    <div className="input">
                                        <OutlinedInput
                                            size="small"
                                            id="outlined-adornment-input"
                                            placeholder="Provizioni"
                                            key={shumaKey}
                                            readOnly
                                            aria-describedby="outlined-input-helper-text"
                                            inputProps={{
                                                'aria-label': 'input',
                                            }}
                                            name='Provizioni'
                                            value={provizioni && provizioni.provizioni}
                                        />
                                    </div>
                                </div>
                                <div className="paysera-inputLabel">
                                    <label htmlFor="Provizioni">Shuma Totale</label>
                                    <div className="input">
                                        <OutlinedInput
                                            size="small"
                                            id="outlined-adornment-input"
                                            placeholder="Provizioni"
                                            endAdornment={<FaEuroSign />}
                                            readOnly
                                            key={shumaKey}
                                            aria-describedby="outlined-input-helper-text"
                                            inputProps={{
                                                'aria-label': 'input',
                                            }}
                                            name='strVleraTotale'
                                            value={provizioni && provizioni.strtotal_pagesa}
                                        />
                                    </div>
                                </div>
                                <PaymentMethodSelector
                                    paymentMethodCode={paymentMethodCode}
                                    onPaymentMethodChange={handlePaymentMethodCode}
                                    onPaymentMethodClick={clickPaymentMethodCode}
                                />
                                <div className="p-buttons">
                                    <div className="payForm-btn">
                                        <Button type="button" variant="outlined" onClick={handleBack}>
                                            Kthehu
                                        </Button>
                                        {/* <Button
                                            id="payNow"
                                            type="button"
                                            variant="contained"
                                            onClick={handlePayWithLoan}
                                            // disabled
                                            disabled={loanLoading}
                                            startIcon={loanLoading && <CircularProgress size={20} color="inherit" />}
                                        >
                                            {loanLoading ? 'Loading...' : 'Paguaj përmes kredisë'}
                                        </Button> */}
                                        <Button
                                            id="payNow"
                                            type="button"
                                            variant="contained"
                                            onClick={handlePayProcess}
                                            disabled={pagesaLoading}
                                            startIcon={pagesaLoading && <CircularProgress size={20} color="inherit" />}
                                        >
                                            {pagesaLoading ? 'Duke paguar...' : 'Paguaj'}
                                        </Button>
                                    </div>
                                </div>
                            </div>
                        ) : (
                            <Fragment>
                                <div className="skeletonBox-detajet">
                                    <h4 className="skeleton-title-font" >Për të shfaqur detajet e pagesës kërkoni përmes UNIREF.</h4>
                                </div>
                                <div className="skeleton-btn">
                                    <Button type="button" variant="outlined" onClick={handleBack}>
                                        Kthehu
                                    </Button>
                                </div>
                            </Fragment>
                        )}
                    </div>
                </div>
            </div>
            <ReCAPTCHA
                badge="bottomleft"
                sitekey={process.env.REACT_APP_SITE_KEY}
                size="invisible"
                ref={reCaptchaRef}
            />
            <PayseraPayment />
            <LoadingOverlay loader={customLoader} visible={updateLoader} />
        </div>
    )
}

export default Uniref_PaymentFields
